import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {
  
    $('.quick-links').each(function() {
        tns({
            container: $(this)[0],
            autoplay: false,
            autoplayButtonOutput: false,
            speed: 1000,
            touch: true,
            controls: true,
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
            loop: false,
            gutter: 20,
            items: 1,
            preventScrollOnTouch: 'auto',
            responsive: {
                1: {
                  items: 1,
                },
                768: {
                    items: 2,
                },
                981: {
                  items: 3,
                },
                1200: {
                    items: $(this).attr('data-slides') || 4,
                },
              },
        });
    });

    if($(window).width() > 768) {
      $('.quick-links .tile').hover(function() {
        $(this).find('.content p').toggle(400)
      },
      function() {
        $(this).find('.content p').toggle(400)
      });
    }
});



// WEBPACK FOOTER //
// ./scripts/components/quick-links.js